import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "portfolio-grid" }

import { computed, toRef } from 'vue'

    import { KendoGrid } from '@Kendo/Components/KendoGrid'
    import KendoGridColumnsEditorDialog from '@Kendo/Components/KendoGridColumnsEditorDialog.vue'

    import type { ProjectsGridViewModel } from '@Quest/Projects/Components/ProjectsGrid'

    // ---------------- props ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectsGrid',
  props: {
    viewModel: {}
  },
  setup(__props: any) {

    const props = __props

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const grid = computed<KendoGrid | null>(() =>
        vm.value?.grid ?? null
    )

    const columnsEditorDialogOpened = computed<boolean>(() =>
        vm.value?.columnsEditorOpened ?? false
    )

    // ---------------- actions ----------------

    function closeColumnsEditor()
    {
        vm.value.columnsEditorOpened = false
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(KendoGridColumnsEditorDialog, {
      propOpened: columnsEditorDialogOpened.value,
      propGrid: grid.value,
      onCloseDialog: closeColumnsEditor
    }, null, 8 /* PROPS */, ["propOpened", "propGrid"]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { id: "pbGrid" }, null, -1 /* CACHED */))
  ]))
}
}

})